import React from 'react'
import {Flex, Button, List} from '@chakra-ui/react3'
import Icon from '../../components/cms/icon'
import useCtaAction from '../../hooks/useCtaAction'
import PropTypes from 'prop-types'
import CTA from '../../components/cms/cta'
import {AddIcon} from '../../components/icons/index'
import RichText from '../../components/cms/rich-text'
import {normalizeString} from '../../utils/utils'
import PayLater from '../../../components/pay-later'

function CardItem({card, headingLevel, styles, trackingContext}) {
    const ctaProps = useCtaAction({
        action: card.cta?.action,
        openInNewTab: card.cta?.openInNewTab,
        trackingContext
    })

    const hoverEffect = {_hover: {transform: 'scale(1.01)'}}
    const interactiveProps = card.cta?.action?.type ? {...ctaProps, ...hoverEffect} : {}

    return (
        // For WCAG, we need the list elements, then it has to be placed separately within the link with the <a> tag, which is why it cannot be merged.
        <List.Item data-testid="card" aria-label={card?.title} {...styles.listItem}>
            {/*wcag: when focusing this card the screenreader reads headline, cta and the ariaLabel from the button/p with the AddIcon*/}
            <Flex
                {...styles.card}
                {...(card.payLater ? styles.isPayLater : {})}
                {...interactiveProps}
            >
                <Flex {...styles.iconText}>
                    <Icon {...card.icon} />
                    <RichText
                        as={`h${headingLevel + 1}`}
                        {...styles.headline}
                        color="text.secondary"
                    >
                        {card.headline}
                    </RichText>
                </Flex>

                <RichText {...styles.copy}>{card.copy?.text}</RichText>

                {card.payLater ? (
                    <PayLater {...card.payLater} />
                ) : (
                    <>
                        <CTA
                            marginTop="24px"
                            variant="text"
                            as="p"
                            {...card.cta}
                            action={null}
                            onClick={undefined}
                            {...styles.cta}
                        />

                        <Button
                            variant="secondaryGhost"
                            size="md"
                            as="p"
                            type={undefined}
                            {...styles.overlayIcon}
                            aria-label={normalizeString(card?.cta?.screenReader)}
                        >
                            <AddIcon />
                        </Button>
                    </>
                )}
            </Flex>
        </List.Item>
    )
}

CardItem.propTypes = {
    card: PropTypes.shape({
        icon: PropTypes.object,
        headline: PropTypes.string,
        copy: PropTypes.shape({
            text: PropTypes.string
        }),
        title: PropTypes.string,
        cta: PropTypes.shape({
            action: PropTypes.shape({
                type: PropTypes.string,
                value: PropTypes.string
            }),
            openInNewTab: PropTypes.bool,
            id: PropTypes.string,
            screenReader: PropTypes.string
        }),
        payLater: PropTypes.object
    }),
    headingLevel: PropTypes.number,
    styles: PropTypes.object,
    variant: PropTypes.string,
    trackingContext: PropTypes.shape({
        moduleName: PropTypes.string,
        eventLabel: PropTypes.string
    })
}

export default CardItem
